import { useSelector } from "react-redux";

import { AudienciasPage } from "./comun/AudienciasPage";
import { FirstLoginPage } from "./auth/FirstLoginPage";

import { RootState } from "../store";

export const HomePage = () => {   
     
    const { restablecerContrasena } = useSelector( ( state: RootState ) => state.auth );

    return (
        <>     
            {
                restablecerContrasena
                ?
                    <FirstLoginPage />
                :     
                    <AudienciasPage />
            }
        </>        
    )
}
